import { createFileRoute } from "@tanstack/react-router";

// Thẻ nằm trên URL để gửi được đường dẫn thẳng tới đúng thẻ (khuôn
// /affiliates, /retouch, /cskh): tiến độ · giao KPI.
type BranchKpiSearch = { tab?: string | undefined };

export const Route = createFileRoute("/_app/branch-kpi/")({
  validateSearch: (search: Record<string, unknown>): BranchKpiSearch => ({
    tab: typeof search.tab === "string" ? search.tab : undefined,
  }),
});
